export default {
  form: {
    header: {
      label: 'Otsikko',
      placeholder: 'Otsikko',
    },
    discount_badge: {
      label: 'Alennusmerkki',
      placeholder: '10 EUR',
    },
    description: {
      label: 'Kuvaus',
      placeholder: 'Kuvaus',
    },
    qr_code_header: {
      label: 'Infolaatikon otsikko',
      placeholder: 'Infolaatikon otsikko',
    },
    qr_code_description: {
      label: 'UI-ruudun kuvaus',
      placeholder: 'UI-ruudun kuvaus',
    },
    footer: {
      label: 'Alatunnisteen teksti',
      placeholder: 'Kirjoita alatunnisteen teksti',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Valitse URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Ensisijainen väri',
    },
    background_color: {
      label: 'Taustaväri',
    },
    cover_image: {
      label: 'Kansikuva',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flyerin lataaminen epäonnistui',
  },
};
